<style lang="scss" scoped>
/deep/ .comp-work-hours-dialog {
    max-width: 800px;
}
</style>

<template>
    <div>
        <el-dialog title="验证半小时时间段是否在工作" top="5vh" custom-class="c-el-dialog comp-work-hours-dialog" 
        :visible.sync="showDialog" :before-close="_close" :close-on-click-modal="false" append-to-body>
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column label="任务类型" align="center">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.workType == 1" size="small">挪车</el-tag>
                        <el-tag type="warning" v-if="scope.row.workType == 2" size="small">换电</el-tag>
                        <el-tag type="success" v-if="scope.row.workType == 3" size="small">巡检</el-tag>
                        <el-tag type="danger" v-if="scope.row.workType == 4" size="small">维修</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="index" label="在工作的半小时时段" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.halfHourDesc }}
                    </template>
                </el-table-column>
                <el-table-column prop="startTime" label="任务开始时间" align="center"></el-table-column>
                <el-table-column prop="endTime" label="任务结束时间" align="center"></el-table-column>
            </el-table>
            <span slot="footer">
                <el-button size="small" @click="_close()">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "compWorkHours",
    data() {
        return {
            showDialog: false,
            tableData: []
        }
    },
    methods: {
        open(item) {
            this.tableData = JSON.parse(JSON.stringify(item))
            this.tableData = this.tableData.map(x => {
                let hs = Math.floor(x.index / 2)
                let ms = x.index % 2 == 0 ? '00' : '30'
                x.halfStartTime = `${hs >= 10 ? hs : '0' + hs}:${ms}`
                let he = Math.floor((x.index + 1) / 2)
                let me = (x.index + 1) % 2 == 0? '00' : '30'
                x.halfEndTime = `${he >= 10 ? he : '0' + he}:${me}`
                x.halfHourDesc = `${x.halfStartTime}-${x.halfEndTime}`
                return x
            })
            this.showDialog = true
        },
        _close() {
            this.showDialog = false
        }
    }
}
</script>